module.exports = __webpack_public_path__ + "img/1.58260645.jpg";